import React, { Component } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import styles from '../styles/frontend/News.css';

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DataTable1: [],
      DatatableImage1: {},
      DatatableImage2: {},
    };
  }

  handleMapClick = () => {
    window.open('https://www.google.com/maps', '_blank');
  };

  render() {
    return (
      <div className={styles.pageContainer} style={{ backgroundImage: "url('/images/img__3.png')", backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <Header />

        <Container className="mt-4">
          <Row className="mb-4 text-center">
            <p className="section-subtitle">ศูนย์เครือข่าย</p>
            <h1 className="section-title">ศูนย์ EEC Nets - Semi-conductor</h1>
          </Row>

          <Row className="justify-content-center py-4">
            <Col xs={12} className="position-relative text-center">
              <Image 
                src="/images/img_rectangle_8.png" 
                alt="Semi-conductor Technology" 
                className="img-fluid rounded"
                style={{ width: '100%', maxHeight: '500px', objectFit: 'cover' }}
              />
              <div 
                style={{
                  position: 'absolute',
                  bottom: '-40px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: '#fff',
                  borderRadius: '1rem',
                  padding: '0.5rem',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                  width: '120px',
                  height: '120px',
                }}
              >
                <Image 
                  src="/images/img_sealofkmutnbsvg_1.png" 
                  alt="KMUTNB Seal" 
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>

          <Row className="px-3 py-4 mt-6 justify-content-center">
            <Col lg={8} className="mb-4">
              <div className="news-content">
                <h2 className="section-heading">ศูนย์ EEC Nets - Semi-conductor</h2>

                <p>
                  หรือชื่อเต็ม: ศูนย์เครือข่ายพัฒนาบุคลากรอุตสาหกรรมเซมิคอนดักเตอร์ (Semi-conductor Center) 
                  ตั้งอยู่ภายใต้การดูแลของ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ (มจพ.)
                </p>

                <h3 className="section-subheading">วัตถุประสงค์หลักของศูนย์</h3>

                <ul>
                  <li>พัฒนาบุคลากรในสาขาเซมิคอนดักเตอร์ สร้างทักษะที่จำเป็นสำหรับอุตสาหกรรมเซมิคอนดักเตอร์</li>
                  <li>จัดอบรมหลักสูตรเฉพาะทางร่วมกับภาคอุตสาหกรรม เช่น การออกแบบชิป, การผลิตไมโครชิป, การทดสอบ, การประกอบ ฯลฯ</li>
                  <li>เป็นศูนย์กลางฝึกอบรมในระดับสากล รองรับผู้เข้าอบรมทั้งนักศึกษา ครูอาจารย์ และบุคลากรจากภาคเอกชน</li>
                  <li>สนับสนุนอุตสาหกรรมเป้าหมายใน EEC เช่น Smart Electronics, AI, IoT, และ EV</li>
                </ul>

                <h3 className="section-subheading">ตัวอย่างการดำเนินงาน</h3>
                <ul>
                  <li>เปิดหลักสูตร "Digital IC Design and Semiconductor Packaging"</li>
                  <li>จัด Bootcamp ฝึกงานร่วมกับบริษัท</li>
                  <li>มีความร่วมมือกับหน่วยงานทั้งในและต่างประเทศ เช่น TSMC, IMEC, GlobalFoundries ฯลฯ</li>
                  <li>มีเป้าหมายผลิตบุคลากรระดับปริญญาตรี – ปริญญาเอก และ Reskill/Upskill แรงงานอุตสาหกรรม</li>
                </ul>
              </div>
            </Col>

            <Col lg={4} className="mb-4">
              <div className="sidebar-box">
                <div className="sidebar-item">
                  <img src="/images/img_people.svg" alt="People" className="icon" />
                  <span className="label">จำนวนบุคลากร</span>
                  <p className="value">จำนวนทั้งสิ้น 100 คน</p>
                </div>

                <div className="sidebar-item">
                  <img src="/images/img_vuesax_bold_briefcase.svg" alt="Experience" className="icon" />
                  <span className="label">Experience</span>
                  <p className="value">Minimum 1 Year</p>
                </div>

                <div className="sidebar-item">
                  <img src="/images/img_call.svg" alt="Phone" className="icon" />
                  <span className="label">ติดต่อ</span>
                  <p className="value">โทรศัพท์ : 0-2555-2000</p>
                </div>

                <div className="sidebar-item">
                  <img src="/images/img_sms.svg" alt="Email" className="icon" />
                  <span className="label">อีเมล</span>
                  <p className="value">contact@op.kmutnb.ac.th</p>
                </div>

                <div className="sidebar-item">
                  <img src="/images/img_vuesax_bold_global.svg" alt="Website" className="icon" />
                  <span className="label">เว็บไซต์</span>
                  <p className="value">https://www.kmutnb.ac.th</p>
                </div>

                <div className="sidebar-item">
                  <img src="/images/img_vuesax_bold_location.svg" alt="Location" className="icon" />
                  <span className="label">ที่ตั้ง</span>
                  <p className="value">มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ 1518 ถนนประชาราษฎร์ 1 แขวงวงศ์สว่าง เขตบางซื่อ กรุงเทพมหานคร 10800</p>
                </div>

                <div className="map-box mb-3">*** MAP ***</div>

                <Button 
                  onClick={this.handleMapClick}
                  className="w-100 bg-global-12 text-global-6 border border-global-12 d-flex align-items-center justify-content-center gap-2"
                >
                  <img src="/images/img_map.svg" alt="Map" className="me-2" />
                  ไปยังแผนที่
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default News;
